module.exports = __webpack_public_path__ + "static/media/desc.3216ab62.svg";